module.exports = __webpack_public_path__ + "static/img/T7201Test.9cd9051a.png";